<template>
    <div>
        <h2 v-if="flightdirection === 'outward'">{{ tab_header_flightdetailsoutwardservices[getCurrentLocale] }}:</h2>
        <h2 v-if="flightdirection === 'return'">{{ tab_header_flightdetailsreturnservices[getCurrentLocale] }}:</h2>


        <!-- >>> 'Flight' Part (OUT/RET) -->
        <div class="intro table-wrapper full-width hidden-table-sm box" style="border-spacing: 8px;">
            <div class="col-md-4 table-cell sdr-box">
                <dl class="term-description">
                    <dt>{{ airline[getCurrentLocale] }}:</dt><dd>Schauinsland</dd>
                    <dt>{{ flighttype[getCurrentLocale] }}:</dt><dd>Economy</dd>
                </dl>
            </div>
            <div class="col-md-8 table-cell">
                <div class="detailed-features booking-details">
                    <div class="sdr-box">
                        <h4 class="box-title" v-if="flightdirection === 'outward'">{{ from[getCurrentLocale] }} {{ get_ServicesBookingnoDepArprtNameOutuward }} {{ to[getCurrentLocale] }}  {{ get_ServicesBookingnoDesArprtNameOutward }}<small>{{ outwardflight[getCurrentLocale] }}</small></h4> <!-- out -->
                        <h4 class="box-title" v-if="flightdirection === 'return'">{{ from[getCurrentLocale] }} {{ get_ServicesBookingnoDepArprtNameReturn }} {{ to[getCurrentLocale] }}  {{ get_ServicesBookingnoDesArprtNameReturn }}<small>{{ returnflight[getCurrentLocale] }}</small></h4> <!-- ret -->
                    </div>
                    <div class="table-wrapper flights">
                        <div class="table-row first-flight">
                            <div class="table-cell logo">
                                <img src="/res/images/sdr140x30.png" alt="Schauinsland" style="padding-bottom:3px;">
                            </div>
                            <div class="table-cell timing-detail">
                                <div class="timing">
                                    <div class="check-in">
                                        <label>{{ takeoff[getCurrentLocale] }}</label>
                                        <span v-if="flightdirection === 'outward'">{{ get_ServicesBookingnoSearchResults[0].outwardFlight.departureDateTimeLocal | dateFlightCart }}, {{ get_ServicesBookingnoSearchResults[0].outwardFlight.departureDateTimeLocal | momentTime }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ get_ServicesBookingnoSearchResults[0].returnFlight.departureDateTimeLocal | dateFlightCart }}, {{ get_ServicesBookingnoSearchResults[0].returnFlight.departureDateTimeLocal | momentTime }}</span> <!-- ret -->
                                    </div>
                                    <div class="duration text-center">
                                        <i class="soap-icon-clock"></i>
                                        
                                        <span v-if="flightdirection === 'outward'">{{ get_ServicesBookingnoSearchResults[0].outwardFlight.dur | durationFlightCart }}</span>
                                        <span v-if="flightdirection === 'return'">{{ get_ServicesBookingnoSearchResults[0].returnFlight.dur | durationFlightCart }}</span>  
                                       
                                    </div>
                                    <div class="check-out">
                                        <label>{{ landing[getCurrentLocale] }}</label>
                                        <span v-if="flightdirection === 'outward'">{{ get_ServicesBookingnoSearchResults[0].outwardFlight.destinationDateTimeLocal | dateFlightCart }}, {{ get_ServicesBookingnoSearchResults[0].outwardFlight.destinationDateTimeLocal | momentTime }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ get_ServicesBookingnoSearchResults[0].returnFlight.destinationDateTimeLocal | dateFlightCart }}, {{ get_ServicesBookingnoSearchResults[0].returnFlight.destinationDateTimeLocal | momentTime }}</span> <!-- out -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <<< 'Flight' Part (OUT/RET) -->


        <!-- >>> 'Pax&Srvcs' Part (OUT/RET) -->
        <div class="booking-section sdr-box" style="padding:0px; padding-top: 10px;" v-for="(pax, index) in get_ServicesBookingnoSearchResultsPassengersSorted" v-bind:key="index">
            <h4 class="paxheadline">{{ trnslPaxSalutations(pax.salutation) }} {{ pax.firstName }} {{ pax.lastName }} ({{ born[getCurrentLocale] }}: {{ pax.birthdate | birthdate }})</h4>
            <div class="table-cell cruise-itinerary">
                <div class="sdr-box" style="padding-top: 0px; padding-bottom:0px; padding-left: 0px; padding-right: 0px;">
                    <!-- flightdirection === out -->
                    <table v-if="flightdirection === 'outward'"> 
                        <tbody>
                            <!-- out flight  -->
                            <tr> 
                                <td><b>{{ flightpriceservices[getCurrentLocale] }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small"> - </td>
                            </tr>
                            <!-- out seat  -->
                            <tr v-if="getSeatData(pax.outboundServices).length > 0">
                                <td>{{ seat[getCurrentLocale] }}: <b>{{ getSeatData(pax.outboundServices)[0].seatName.seatName | truncate(17, '...') }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ getSeatData(pax.outboundServices)[0].price !== undefined ? getSeatData(pax.outboundServices)[0].price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                            <!-- out services -->
                            <tr v-for="(srvcs, index2) in pax.outboundServices.filter(x => (x.code != 'SEAT'))" v-bind:key="index2"> 
                                <td>{{ srvcs.label }}</td>
                                <td style="text-transform: none;"><span v-if="srvcs.quantity > 1">{{ srvcs.quantity }}x a {{ srvcs.price | rndAmntRUAFWZ }}</span></td>
                                <td class="total-price-value-small">{{ srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.quantity) : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- flightdirection === ret -->
                    <table v-if="flightdirection === 'return'"> 
                        <tbody>
                            <!-- out flight  -->
                            <tr> 
                                <td><b>{{ flightpriceservices[getCurrentLocale] }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small"> - </td>
                            </tr>
                            <!-- out seat  -->
                            <tr v-if="getSeatData(pax.inboundServices).length > 0">
                                <td>{{ seat[getCurrentLocale] }}: <b>{{ getSeatData(pax.inboundServices)[0].seatName.seatName | truncate(17, '...') }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ getSeatData(pax.inboundServices)[0].price !== undefined ? getSeatData(pax.inboundServices)[0].price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                            <!-- out services -->
                            <tr v-for="(srvcs, index2) in pax.inboundServices.filter(x => (x.code != 'SEAT'))" v-bind:key="index2"> 
                                <td>{{ srvcs.label }}</td>
                                <td style="text-transform: none;"><span v-if="srvcs.quantity > 1">{{ srvcs.quantity }}x a {{ srvcs.price | rndAmntRUAFWZ }}</span></td>
                                <td class="total-price-value-small">{{ srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.quantity) : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- <<< 'Pax&Srvcs' Part (OUT/RET) -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flightdirection'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {
        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                tab_header_flightdetailsoutwardservices: {
                    en: 'Your booking details for the outbound flight',
                    de: 'Ihre Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturnservices: {
                    en: 'Your booking details for the inbound flight',
                    de: 'Ihre Buchungsdetails zum Rückflug'
                },
                // >>> --------------------------
                airline: {
                    en: 'Organizer',
                    de: 'Veranstalter',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückflug'
                },
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                flightpriceservices: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                seat: {
                    en: 'Seat',
                    de: 'Sitz',
                },                            
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'get_ServicesBookingnoSearchResults', 
                'get_ServicesBookingnoSearchResultsPassengersSorted',
                'get_ServicesBookingnoDepArprtNameOutuward',
                'get_ServicesBookingnoDesArprtNameOutward',
                'get_ServicesBookingnoDepArprtNameReturn',
                'get_ServicesBookingnoDesArprtNameReturn',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * dateFlightCart()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            dateFlightCart: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
                // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

            }, // dateFlightCart()

            /*******************************************************************
            * durationFlightCart()
            *
            * Desc: Calculates "Travel Time".
            *
            * @param {int} a (duration in seconds)
            * @return {string}
            */
            durationFlightCart: function(a) {

                let hours = Math.floor(a / 3600),
                    minutes = Math.floor(a / 60) - hours * 60,
                    hours_txt = 'S', // H
                    minutes_txt = ' h'; // M


                if (minutes === 0) {
                    return hours + ':00' + minutes_txt;
                } else if (minutes.toString().length === 1) {
                    return hours + ':0' + minutes + '' + minutes_txt;
                } else {
                    return hours + ':' + minutes + '' + minutes_txt;
                }

            }, // eof durationFlightCart()

        }, // eof filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * trnslPaxTypes()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxTypes: function(type) {

                var me = this,
                    trnsltdType = '';


                me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxTypes');
                switch(type) {
                case 'ADT':
                    trnsltdType = me.adult[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdType = me.child[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdType = me.infant[me.getCurrentLocale];
                    break;
                default:
                    trnsltdType = '';
                }


                return trnsltdType;

            }, // eof trnslPaxTypes()

            /*******************************************************************
            * trnslPaxSalutations()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxSalutations: function(type) {

                var me = this,
                    trnsltdSalutation = '';


                me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxSalutations');
                switch(type) {
                case 'MR':
                    trnsltdSalutation = me.mr[me.getCurrentLocale];
                    break;
                case 'MRS':
                    trnsltdSalutation = me.mrs[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdSalutation = me.chd[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdSalutation = me.inf[me.getCurrentLocale];
                    break;
                default:
                    trnsltdSalutation = '';
                }


                return trnsltdSalutation;

            }, // eof trnslPaxSalutations()


            /*******************************************************************
            * getSeatData()
            *
            * Desc:
            *
            * @param
            * @return
            */
            getSeatData: function(paxServices) {

                var me = this,
                    seatData = [];
                    

                me.$toc('>>> booking/overview/FlightDetails.vue >>> getSeatData');                
                seatData = paxServices.filter(x => (x.code == 'SEAT'));


                return seatData;

            }, // eof getSeatData()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }


    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a, .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #F5F5F5;
    }
    .booking-details .other-details .total-price-value {
        font-size:1.9167em
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt, .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active, #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }

    .cruise-itinerary td {
        line-height: 1.8em;
    }



    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large, input[type="button"].button.btn-large, a.button.btn-large {
            font-size: 1.0em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/services/pagecontent/BookingnoFlightDetails.vue